"use client";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import React, { useRef } from "react";

interface SectionHeaderProps {
  title?: string;
  highlightedTitle?: string;
  bodyText?: string;
  triggerStart?: string;
}

function SectionHeader({
  title,
  highlightedTitle,
  bodyText,
  triggerStart = "200",
}: Readonly<SectionHeaderProps>) {
  const headerRef = useRef(null);
  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(
        "#headerText",
        { autoAlpha: 0, y: -50 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          scrollTrigger: {
            trigger: "#headerText",
            start: `top bottom-=${triggerStart}`,
            toggleActions: "play none none reverse",
          },
        },
      );
      if (bodyText) {
        gsap.fromTo(
          "#headerSubtitle",
          { autoAlpha: 0, scale: 0.8 },
          {
            autoAlpha: 1,
            scale: 1,
            duration: 0.5,
            scrollTrigger: {
              trigger: "#headerSubtitle",
              start: `top bottom-=${triggerStart}`,
              toggleActions: "play none none reverse",
            },
          },
        );
      }
    },
    { scope: headerRef },
  );

  return (
    <div
      ref={headerRef}
      className="flex w-full flex-col items-center justify-center gap-5 overflow-hidden md:min-h-[150px] xl:min-h-[250px]"
    >
      <h1
        id="headerText"
        className="mx-auto max-w-3xl px-5 text-center text-3xl font-bold md:text-4xl xl:text-5xl"
      >
        {highlightedTitle && (
          <span className="font-Satoshi-Bold font-bold">
            {highlightedTitle}
          </span>
        )}{" "}
        <span className="font-Satoshi-Medium font-normal">{title}</span>
      </h1>
      {bodyText && (
        <p
          id="headerSubtitle"
          className="mt-4 max-w-3xl text-center font-Satoshi-Medium text-lg lg:text-base xl:text-lg"
        >
          {bodyText}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;
